import request from "@/service";

// 统计-日活统计-jcc
export function activityDay(data) {
  return request({
    url: "/user/sys/activity/statistic/day",
    method: "post",
    data
  });
}

//统计-月活统计-jcc
export function activitymonth(data) {
  return request({
    url: "/user/sys/activity/statistic/month",
    method: "post",
    data
  });
}

/* 日活统计-导出-qinzl */
export function exportDay(data) {
  return request({
    url: `/user/sys/activity/statistic/exportDay`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}

/* 月活统计-导出-qinzl */
export function exportMonth(data) {
  return request({
    url: `/user/sys/activity/statistic/exportMonth`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}
